import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { QUARRY_GEO } from './quarrygeo.ts';

/**
 * Quarry No. 9: a working open-pit stone quarry on a stormy afternoon. The pit is a terraced oval round the middle of the map
 * (its ledges and haul ramps are polygons in quarrygeo.ts): long sightlines across the wet pit floor round B, a middle bench where
 * a haul truck waits by its ramp, and the top bench round A and C. Round the rim the works are cramped: the workshop, the crusher
 * with its conveyors and gravel cones, the control cabin and the block pallets to the north; the site office, canteen, fuel tank and
 * weighbridge by the red camp; the blasting shed in its earth bund, the settling pond, the tower crane and the block yard to the south.
 * The east half is the half-turn, and the theme dresses each twin as the other place of its pair (src/client/themes/quarry*.ts).
 * Legend: @ rock ledge or spoil bund, $ cut stone block, ! steel plant, : portacabin wall, ; corrugated steel shed.
 */
const WEST = `
  ............................................................
  ............................................................
  ............................................................
  ...;;;;;;;;;;;;;;....@@.....................................
  ...;............;....@@.....................................
  ...;.cc.........;....@@.!!!!!!!!............................
  ...;............;....@@.!!!!!!!!............................
  ...;....................!!!!!!!!............................
  ...;....................!!!!!!!!............................
  ...;..e......o..........!!!!!!!!..........$$................
  ...;............;....@@.!!!!!!!!..........$$................
  ...;............;....@@..........g..........................
  ...;;;;;....;;;;;....@@.....................................
  .......................b..........::::::....................
  ..................................:....:.....l..............
  .......................................:....................
  .FFFF..............$$..........c.......:....................
  .FFFF.......$$.....$$.............::::::......$$............
  .FFFF..$$...$$............$$..................$$............
  .FFFF..$$.......c.........$$..................::::::...FFFF.
  .FFFF.........................................:....:...FFFF.
  ..............................................:...i:...FFFF.
  ..............................................:....:........
  ..............................................::..::........
  ...............l............................................
  ............................................................
  .................::::::.....................................
  ..::::::::::::...:....:................................$$...
  ..:..........:...:..c.:................................$$...
  ..:...m..........:....:.....................................
  ..:...................:..........@@@........................
  ..:.......c...........:..........@@@........................
  ..:..........:........:.....................................
  ..:::...::::::...:....:...$$................................
  .................:....:...$$................................
  .................:....:.....................................
  .................:....:...............$$....................
  .................::..::...............$$....................
  ...............................l............................
  ............................................................
  .........................p..................................
  ........................................$$..................
  ........................................$$..................
  ............................................................
  .............................@@.............................
  .............@@..............@@.............................
  .............@@............................b................
  .............@@.............................................
  .............@@.............................................
  .............@@..........................................c..
  .............@@.............................................
  .............@@...............$$............................
  ......XXXXX..@@...............$$.................$$$........
  ......XXXXX......................................$$$........
  ......XXXXX......................................$$$........
  ......XXXXX.........................c.................$$....
  ......XXXXX...c.......................................$$....
  ......XXXXX........................................a........
  ......XXXXX................$................................
  ......XXXXX................$....A...........................
  ......XXXXX................$................................
  ......XXXXX.................................................
  ......XXXXX....@@...........................................
  ......XXXXX....@@...........................................
  ......XXXXX....@@...........................................
  ......XXXXX....@@.................$$........................
  ......XXXXX....@@.................$$........................
  ......XXXXX....@@...........................................
  ......XXXXX....@@...........................................
  ...............@@..................................$$$......
  ...............@@........................c.........$$$......
  ............................................................
  ............................................................
  ............................................................
  ............b.................@@@.....$$....................
  ..............................@@@.....$$....................
  ............................................................
  ............................................................
  ........l...................................................
  .....................:::::::................................
  .....................:.....:................................
  .......................i...:................................
  ...........................:................................
  .....................:.....:................................
  .....................:::::::................................
  ............................................................
  ....o.............................l.........................
  ............................................................
  ..................c.........................................
  ............................................................
  ..............................$$............................
  ..............................$$............................
  ............................................................
  ............................................................
  ........................$$..................................
  ........................$$.......................$$.........
  ....................c............................$$.........
  ............................................................
  ...@@...........@@.............................$$...........
  ...@@...........@@.............................$$...........
  ...@@..;;..;;;..@@....................b.....................
  ...@@..;.....;..@@..........................................
  ...@@..;.....;..............................................
  ...@@..;..b.................................................
  ...@@..;..............................e.....................
  ...@@..;...g.;..............................................
  ...@@..;;;;;;;..@@....................................$$....
  ...@@...........@@....................................$$....
  ...@@...........@@............................l.............
  ...@@@@@@@@@@@@@@@..........................................
  ...@@@@@@@@@@@@@@@..........................................
  ..............................$$..$$..$$..$$................
  ..FFFFF.......................$$..$$..$$..$$................
  ..FFFFF.....................................................
  ..FFFFF......................c..............p...............
  ..FFFFF.........................$$..$$..$$..................
  ..FFFFF.........................$$..$$..$$..................
  ..FFFFF.....................................................
  ............................................................
  ............................................................
`;

export const QUARRY = withGeometry(gridMap('Quarry', WEST, 'quarry'), QUARRY_GEO);
